module.exports = __webpack_public_path__ + "img/IMG_1982.e5903ef4.jpg";